export function hashColor(str) {
  if (!str) return 'hsl(0, 70%, 60%)'

  const hash = str.split('').reduce((acc, char) =>
    char.charCodeAt(0) + ((acc << 5) - acc), 0)

  const hue = Math.abs(hash) % 360
  return `hsl(${hue}, 70%, 60%)`
}
